/**
 * @file mix-in設定
 */

export { clipPathHidden } from "./clipPathHidden";
export { mediaQuery } from "./mediaQuery";
